// Display helpers. The API and the database keep ISO dates (yyyy-mm-dd); only what people read changes.

// "2026-09-19" -> "19-09-2026". Plain string handling on purpose: no Date object, so no timezone shift.
export const fmtDate = (value) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || "");
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return value || "-";
};

// An ISO UTC timestamp (created_at/waktu_dapat_kamar) -> "19-09-2026 15:04" in WIB (the hospital's timezone).
export const fmtDateTime = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Jakarta", year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", hour12: false,
    }).formatToParts(d).map((p) => [p.type, p.value])
  );
  return `${parts.day}-${parts.month}-${parts.year} ${parts.hour}:${parts.minute}`;
};

// Duration between two ISO timestamps, e.g. "2 hari 3 jam" or "45 menit". null when either side is missing/invalid.
export const fmtSelisihWaktu = (startIso, endIso) => {
  if (!startIso || !endIso) return null;
  const start = new Date(startIso);
  const end = new Date(endIso);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;
  let totalMinutes = Math.max(0, Math.round((end - start) / 60000));
  const days = Math.floor(totalMinutes / 1440);
  totalMinutes -= days * 1440;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes - hours * 60;
  const parts = [];
  if (days) parts.push(`${days} hari`);
  if (hours) parts.push(`${hours} jam`);
  if (minutes || parts.length === 0) parts.push(`${minutes} menit`);
  return parts.join(" ");
};
